import { useState, ReactNode, useEffect } from 'react'

import MonthAccordion from 'features/RiskManagement/Components/MonthAccordion'
import { ISavedState } from 'features/RiskManagement/Assessments'

interface ISavedStatesContainer {
  stateType: string
  subheading?: ReactNode
  baselineList: ISavedState[]
}

interface IAccordionData {
  year: number
  month: Array<{
    value: number
    states: ISavedState[]
  }>
}

interface IListAccordionProps {
  yearContainer: IAccordionData
}

const ListAccordion = ({ yearContainer }: IListAccordionProps) => {
  return (
    <div key={yearContainer.year} className='mb-16 flex'>
      <div className='w-16 border-r-2 border-gray-500 relative'>
        <label
          className={[
            'absolute origin-top-right right-14 top-3 -rotate-90 text-6xl',
            'font-extrabold text-gray-300'
          ].join(' ')}
        >
          {yearContainer.year}
        </label>
      </div>
      <div className='w-full'>
        {yearContainer.month.map(
          (monthContainer: { value: number; states: ISavedState[] }) => {
            return (
              <MonthAccordion
                key={monthContainer.value}
                monthList={monthContainer}
                year={yearContainer.year}
              />
            )
          }
        )}
      </div>
    </div>
  )
}

const SavedStatesContainer = ({
  stateType,
  subheading,
  baselineList
}: ISavedStatesContainer) => {
  const [accordionData, setAccordionData] = useState<IAccordionData[]>([])

  useEffect(() => {
    const tempAccordionData: IAccordionData[] = []

    baselineList.forEach((state) => {
      const tempDate = new Date(state.dateCreated)
      const tempYear = tempDate.getFullYear()
      const tempMonth = tempDate.getMonth() + 1
      let yearFound = false

      tempAccordionData.forEach(
        (yearContainer: { year: number; month: any[] }) => {
          let monthFound = false

          if (tempYear === yearContainer.year) {
            yearContainer.month.forEach((monthContainer: any) => {
              if (tempMonth === monthContainer.value) {
                if (monthContainer.states === undefined) {
                  monthContainer.states = []
                }

                monthContainer.states.push(state)
                monthFound = true
              }
            })

            if (!monthFound) {
              if (yearContainer.month === undefined) {
                yearContainer.month = []
              }

              yearContainer.month.push({ value: tempMonth, states: [state] })
            }

            yearFound = true
          }
        }
      )

      if (!yearFound) {
        tempAccordionData.push({
          year: tempYear,
          month: [{ value: tempMonth, states: [state] }]
        })
      }
    })

    setAccordionData(tempAccordionData)
  }, [baselineList])

  return (
    <div className='flex px-6 pb-6 pt-7 xl:pl-[6.125rem]'>
      <div className='flex flex-1 flex-col justify-around'>
        <span className='py-4 text-lg font-bold'>
          {stateType}
          <span className='ml-6 font-normal italic text-gray-700'>
            {subheading}
          </span>
        </span>
        <hr className='h-0.5 bg-gray-300' />
        {accordionData.map((yearContainer, index) => (
          <ListAccordion
            key={`${yearContainer.month}-${yearContainer.year}-${index}`}
            yearContainer={yearContainer}
          />
        ))}
      </div>
    </div>
  )
}

export default SavedStatesContainer
